import {setABToStorage} from '../storage';

const setABAndPostToParent = () => {
  const abNumber = setABToStorage();

  window.parent.postMessage(
    {
      data: {
        abNumber
      },
      scope: 'mol-fe-xpmodule-news-search-ab'
    },
    '*'
  );
};

setABAndPostToParent();
